import React from 'react'
import { useLocation } from 'react-router-dom'
import { Panel, Tag, Text } from 'rsuite'

// Type for location state
interface LocationState {
  data: any[] // Using any[] as requested since API types aren't properly typed yet
}

const Prompts: React.FC = () => {
  const location = useLocation()
  const { data } = location.state as LocationState

  const handleExport = async (): Promise<void> => {
    const jsonString = JSON.stringify(data, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `${new Date().getTime()}.json`

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  }

  return (
    <div>
      {data && data.length > 0 && (
        <>
          {data.map((item: any, index: number) => {
            if (
              item.title !== 'summary_ai' &&
              item.title !== 'summary_ai_plus'
            ) {
              return (
                <Panel
                  header={item.title}
                  key={index}
                  style={{ marginBottom: '1rem' }}
                  bordered
                >
                  <Text>
                    <Tag color="cyan">AI</Tag> {item?.ai}
                  </Text>
                  {item?.ai_plus && (
                    <>
                      <br />
                      <Text>
                        <Tag color="violet">AI+</Tag> {item?.ai_plus}
                      </Text>
                    </>
                  )}
                </Panel>
              )
            } else if (item.title === 'summary_ai') {
              return (
                <React.Fragment key={index}>
                  <Panel header="Insights" bordered>
                    {item.insights_prompt}
                  </Panel>
                  <Panel header="Conclusion" bordered>
                    {item.conclusion_prompt}
                  </Panel>
                </React.Fragment>
              )
            } else if (item.title === 'summary_ai_plus') {
              return (
                <React.Fragment key={index}>
                  <Panel header="Insights+" bordered>
                    {item.insights_prompt}
                  </Panel>
                  <Panel header="Conclusion+" bordered>
                    {item.conclusion_prompt}
                  </Panel>
                </React.Fragment>
              )
            }
            return null // Handle cases where no condition matches
          })}
          <div
            style={{ position: 'fixed', bottom: 0, right: 0, margin: '1rem' }}
          >
            <Tag
              color="green"
              style={{ cursor: 'pointer' }}
              onClick={handleExport}
            >
              Download as JSON
            </Tag>
          </div>
        </>
      )}
    </div>
  )
}

export default Prompts
